module.exports = __webpack_public_path__ + "static/media/conheca-joinville3.b6f5a1d9.webp";